import React from 'react'
import './effectcontent.scss'

function Effectcontent({ imguri, title, children, type, opacity }) {
  return <div className={`effect_content effect_content_${type} `} style={{ opacity: `${opacity ? 1 : 0.4}` }}>
    <img src={imguri}></img>
    <h2>{title}</h2>
    <p>{children}</p>
  </div>
}

export default Effectcontent